import React, { Component } from 'react';

const withLoadingInterval = (WrappedComponent) => {
    class WithLoadingInterval extends Component {
        constructor(props) {
            super(props);
            this.state = { elapsedTime: 0 };
            this.interval = null;
        }

        componentDidMount() {
            if (this.props.loading) {
                this.startInterval();
            }
        }

        componentDidUpdate(prevProps) {
            if (!prevProps.loading && this.props.loading) {
                this.startInterval();
            } else if (prevProps.loading && !this.props.loading) {
                this.stopInterval();
            }
        }

        componentWillUnmount() {
            this.stopInterval();
        }

        startInterval = () => {
            this.setState({ elapsedTime: 0 });
            this.interval = setInterval(() => {
                this.setState((prevState) => ({
                    ...prevState,
                    elapsedTime: prevState.elapsedTime + 1
                }));
            }, 1000);
        };

        stopInterval = () => {
            clearInterval(this.interval);
            this.setState({ elapsedTime: 0 });
        };

        render() {
            return <WrappedComponent {...this.props} elapsedTime={this.state.elapsedTime} />;
        }
    }

    WithLoadingInterval.displayName = `WithLoadingInterval(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

    return WithLoadingInterval;
};

export default withLoadingInterval;
